import { render, staticRenderFns } from "./Rep_Matematico_Details.vue?vue&type=template&id=5a007086"
import script from "./Rep_Matematico_Details.vue?vue&type=script&lang=js"
export * from "./Rep_Matematico_Details.vue?vue&type=script&lang=js"
import style0 from "./Rep_Matematico_Details.vue?vue&type=style&index=0&id=5a007086&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports